import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Icon, IconName } from './Icon';

export interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'name'> {
  children?: ReactNode;
  secondary?: boolean;
  icon?: IconName;
  ariaLabel?: string;
  testId?: string;
  // Accepted for compatibility with existing call sites; not rendered.
  name?: string;
  'data-testid'?: string;
}

// No default `type`, deliberately: like the Bronson button it replaces, a
// button inside a form is a submit button, so Enter in a search field still
// triggers the search.
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- `name` is taken out so it never reaches the DOM
export function Button({ children, className, secondary, icon, ariaLabel, testId, name, ...otherProps }: ButtonProps) {
  return (
    <button
      data-testid={testId}
      aria-label={ariaLabel}
      {...otherProps}
      className={classNames(
        'ec-btn',
        secondary && 'ec-btn--secondary',
        icon && !children && 'ec-btn--icon-only',
        className
      )}
    >
      {children ? <span className="ec-btn__text">{children}</span> : null}
      {icon ? <Icon name={icon} className="ec-btn__icon" /> : null}
    </button>
  );
}
